<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Onaylar</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->

          <div class="m-portlet m-portlet--mobile">
            
            <div class="m-portlet__body">
              <!--begin: Datatable -->
              <div id="m_table_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                <div class="row"></div>
                <div class="row">
                  <div class="col-sm-12">
                    <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px;"
                    >
                      <thead>
                        <tr role="row">
                      
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 157.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >Talep Sahibi</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 250px;"
                            aria-label="Country: activate to sort column ascending"
                          >Veri Referans No</th>
                 
                           <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Onay Sıra no</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Onay Tipi</th>
                            <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Oluşturma Tarihi</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Statü</th>
                                                    <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Onay Tarihi</th>
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="1"
                            style="width: 95px;"
                            aria-label="Country: activate to sort column ascending"
                          >Açıklama</th>
                          <th
                            class="sorting_disabled"
                            rowspan="1"
                            colspan="1"
                            style="width: 73px;"
                            aria-label="Actions"
                          >Actions</th>
                        </tr>
                      </thead>
                      <tbody v-if="items && items.length">
                        <tr role="row" class="odd" v-for="item in items" v-bind:key="item.id">
                          
                          <td>{{item.requestedUserName}}</td>
                          <td>{{item.referenceId}}</td>
                          <td>{{item.approvePathOrderNumber}}</td>
                          <td>{{item.referenceTypeName}}</td> 
                          <td>{{item.createdDate}}</td> 
                          <td>{{item.statusName}}</td> 
                          <td>{{item.approveDate}}</td> 
                          <td>{{item.description}}</td> 

                          <td nowrap>
                            <button
                               v-confirm="{ok:dialog => approve(dialog,item)}"  
                              class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                              title="View"
                            >
                              <i class="la la-edit"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            
              </div>
            </div>
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {_approve,_getAll} from '../../services/ApproveService'
export default {
  data() {
    return {
      items: []
    };
  },
  created() {
      this.getAll();
  },
  methods: {
    getAll: function() {
    // let loader=this.$loading.show();
      _getAll().then(response=> {
                //  loader.hide();
                 if(response.data.success)
        this.items = response.data.data.items;
      });
     
    },
        approve:function(dialog,item){
        _approve(item).then(response=>{
          if(response.data.success)
          this.getAll()
        });
              dialog.close();
    }
  }
};
</script>